import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetAttributionOverviewV1Query } from './get-attribution-overview-v1-request';
import type { IGetAttributionOverviewV1Response } from './get-attribution-overview-v1-response';
import { getAttributionOverviewV1ResponseSchema } from './get-attribution-overview-v1-response';

export async function getAttributionOverviewV1Api(
  query: IGetAttributionOverviewV1Query = {},
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetAttributionOverviewV1Response>> {
  const params = new URLSearchParams();
  if (query.period) {
    params.set('period', query.period);
  }
  const qs = params.toString();
  return getRequest<IGetAttributionOverviewV1Response>({
    path: `/sys/attribution/v1/overview${qs ? `?${qs}` : ''}`,
    schema: getAttributionOverviewV1ResponseSchema,
    options,
  });
}
